"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EventNames = void 0;
// Please respect alphabetical order
var EventNames;
(function (EventNames) {
    EventNames["ACCOUNT_INFO_SUBMITTED"] = "Account Info Submitted";
    EventNames["AETNA_NY_CLICKED_CTA"] = "Aetna NY - Clicked CTA";
    EventNames["AETNA_NY_IMPRESSION"] = "Aetna NY - Impression";
    EventNames["BANNER"] = "Banner";
    EventNames["BANNER_CLICKED"] = "Clicked Banner";
    EventNames["BANNER_CLOSED"] = "Closed Banner";
    EventNames["BANNER_SEEN"] = "Saw Banner";
    EventNames["CENTER_OR_ANYWHERE_SELECTED"] = "Center or Anywhere Selected";
    EventNames["CHAT"] = "Chat";
    EventNames["CHAT_CLOSED"] = "Chat Closed";
    EventNames["CHAT_OPENED"] = "Chat Opened";
    EventNames["CHAT_STARTED"] = "Chat Started";
    EventNames["CHAT_SUBMITTED"] = "Chat Submitted";
    EventNames["CHECKOUT_COMPLETE"] = "Checkout Complete";
    EventNames["CHECKOUT_STARTED"] = "Checkout Started";
    EventNames["CHECKOUT_STEP_COMPLETED"] = "Checkout Step Completed";
    EventNames["CHECKOUT_STEP_VIEWED"] = "Checkout Step Viewed";
    EventNames["CLICKED_CTA"] = "Clicked CTA";
    EventNames["CLICKED_FILTER"] = "Clicked Filter";
    EventNames["CLICKED_JOIN_BUTTON"] = "Join Button Click";
    EventNames["CLICKED_MAP"] = "Clicked Map";
    EventNames["COMPLETED_ACCOUNT_SETUP"] = "Account Setup Completed";
    EventNames["COMPLETED_CALL_SCHEDULING_FORM"] = "Call Scheduling Form Complete";
    EventNames["CONDITION_CARD_CLICKED"] = "Condition card clicked";
    EventNames["CONDITION_CARD_SEEN"] = "Saw condition card";
    EventNames["CONDITION_CARD_TOGGLER_CLICKED"] = "Condition card toggler clicked";
    EventNames["CONDITION_SPECIFIC_DROPDOWN_MENU_CLICKED"] = "Click on condition-specific drop-down menu";
    EventNames["CONDITION_SPECIFIC_GET_STARTED_CLICKED"] = "Click on condition-specific Get Started";
    EventNames["CONDITION_SPECIFIC_PAGE_VISITED"] = "Condition Specific Page Visited";
    EventNames["CONDITIONS_LIST_FILTER"] = "Conditions List Filter";
    EventNames["CONDITIONS_REVIEW_FILTER"] = "Conditions Review Filter";
    EventNames["CONFIRMATION_CLICKED"] = "Confirmation Clicked";
    EventNames["CONSULT_REQUEST"] = "Consult Request";
    EventNames["COUPON_APPLIED"] = "Coupon Applied";
    EventNames["COUPON_ENTERED"] = "Coupon Entered";
    EventNames["EMAIL_COMPLETED"] = "Email Completed";
    EventNames["FORM"] = "Form";
    EventNames["INSURANCE_INELIGIBLE_CONTINUE_SIGNUP"] = "Continue Signup";
    EventNames["INSURANCE_INELIGIBLE_VIEWED_MODAL"] = "Sees Not Eligable for Aetna NY";
    EventNames["INTERACTION"] = "Interaction";
    EventNames["JOIN_FLOW_ERROR"] = "Join Flow Error";
    EventNames["JOIN_PAGE_VISITED"] = "Join Page Visited";
    EventNames["LD_FLAGS_INITIALIZED"] = "LD Flags Initialized";
    EventNames["LEAD_CAPTURE_FORM_CLOSED"] = "Lead Capture Form Closed";
    EventNames["LEAD_CAPTURE_FORM_POPPED"] = "Lead Capture Form Popped";
    EventNames["LEAD_CAPTURE_FORM_SUBMITTED"] = "Lead Capture Form Submitted";
    EventNames["LOG_IN"] = "Log in";
    EventNames["LOGROCKET"] = "LogRocket";
    EventNames["NEWS_LETTER_SIGNUP"] = "Newsletter Sign Up";
    EventNames["NOTIFY_ME"] = "Notify me";
    EventNames["OPENED_FAQ"] = "OpenedFAQ";
    EventNames["ORDER_COMPLETED"] = "Order Completed";
    EventNames["PAGE"] = "Page";
    EventNames["PAYMENT_INFO_ENTERED"] = "Payment Info Entered";
    EventNames["PAYMENT_SCHEDULING_SELECTED"] = "Payment Schedule Selected";
    EventNames["PRODUCT"] = "Product";
    EventNames["PRODUCT_ADDED"] = "Product Added";
    EventNames["PRODUCT_ADDED_TO_CART"] = "Product Added To Cart";
    EventNames["PRODUCT_SELECTED_UNAVAILABLE"] = "Product Selected Unavailable";
    EventNames["PROVIDED_CANCELLATION_FEEDBACK"] = "Cancellation Feedback Provided";
    EventNames["PROVIDER_MATCHING_COMPONENT_SEEN"] = "Saw provider matching component";
    EventNames["PURCHASE_COMPLETED"] = "Purchase Completed";
    EventNames["QUIZ_COMPLETED"] = "Quiz Completed";
    EventNames["QUIZ_FINISHED"] = "Quiz Finished";
    EventNames["QUIZ_SHOWN"] = "Quiz Shown";
    EventNames["QUIZ_STEP"] = "Quiz Step";
    EventNames["SEE_DETAILS"] = "See details";
    EventNames["SEES_AETNA_NY_OFFER"] = "Sees Aetna NY Offer";
    EventNames["SELECTED_PRODUCT"] = "Product Selected";
    EventNames["SELECTED_PRODUCT_CATEGORY"] = "Product Category Selected";
    EventNames["SPLIT_TEST"] = "Split test";
    EventNames["STARTED_CALL_SCHEDULING"] = "Call Scheduling Started";
    EventNames["STARTED_WITH_PRODUCT"] = "Started with product";
    EventNames["SUBMITTED_FORM"] = "Form Submitted";
    EventNames["USER_SWITCHED_SPLIT_TEST"] = "user_switched_split_test_variant";
    EventNames["VIDEO"] = "Video";
    EventNames["VIDEO_ENDED"] = "Video Ended";
    EventNames["VIDEO_PAUSE"] = "Video Pause";
    EventNames["VIDEO_PLAYING"] = "Video Playing";
    EventNames["VIEWED_AETNA_NY_PAGE"] = "Viewed Aetna NY Page";
    EventNames["ZIP_COMPLETED"] = "Zip Completed";
    EventNames["ZIP_EMAIL_COMPLETED"] = "Zip Email Completed";
})(EventNames = exports.EventNames || (exports.EventNames = {}));
//# sourceMappingURL=event-names.js.map